/* Highcharts global configuration */
/* eslint-disable */
var ReactHighcharts = require('react-highcharts');

import 'style/_colors.scss';

/**
 * Read value from stylesheet rule
 * @param {String} style The property to read
 * @param {String} selector The selector to apply
 * @param {String} sheetIdx The stylesheed index to read, if not set, loops on all
 * @returns {*} void
 */
function getStyleRuleValue(style, selector, sheetIdx) {
    var sheets = typeof sheetIdx !== 'undefined' ? [document.styleSheets[sheetIdx]] : document.styleSheets;
    for (let i = 0, l = sheets.length; i < l; i++) {
        const sheet = sheets[i];
        if( !sheet || !sheet.cssRules ) { continue; }
        for (let j = 0, k = sheet.cssRules.length; j < k; j++) {
            const rule = sheet.cssRules[j];
            if (rule.selectorText && rule.selectorText.split(',').indexOf(selector) !== -1) {
                return rule.style[style];
            }
        }
    }
    return null;
}

/**
 * Returns color scheme of CSS classes ".text-color-n"
 * @returns {Array} The colors array
 */
export const readColors=() =>{
    let i = 1,
        color = null,
        cont = true;
    const colors = [
        // Color with index 0 is not used on text classes because of a sass limitation
    ];
    do {
        color = getStyleRuleValue('color', '.text-color-' + i, 0); // Warning, always reads from first stylesheet
        if (color) {
            colors.push(color);
            i++;
        } else {
            cont = false;
        }
    } while (cont);

    return colors;
}

/**
 * Set default highchart theme
 */
ReactHighcharts.Highcharts.setOptions({
	colors: readColors(),
	chart: {
		backgroundColor: null,
		spacing: [10,0,10,0],
		style: {
			fontFamily: '"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif"'
		}
	},
	title: {
		style: {
			color: '#666',
			fontSize: '16px',
			fontWeight: '500'
		}
	},
	subtitle: {
		style: {
			color: 'black'
		}
	},
	tooltip: {
		borderWidth: 0,
		backgroundColor: 'rgba(255,255,255,0.9)',
		style: {
			fontWeight: '500'
		}
	},
	legend: {
		itemStyle: {
			fontWeight: '500',
			fontSize: '13px'
		},
		backgroundColor: null,
		borderWidth: 0
	},
	xAxis: {
		labels: {
			style: {
				color: '#6e6e70'
			}
		},
		gridLineColor: "#e4e8e7",
		gridLineWidth: 1
	},
	yAxis: {
		labels: {
			style: {
				color: '#6e6e70'
			}
		},
		gridLineColor: "#e4e8e7",
		gridLineWidth: 1
	},
	plotOptions: {
		series: {
			shadow: false
		},
		candlestick: {
			lineColor: '#404048'
		},
		map: {
			shadow: false
		},
		column: {
			borderColor: 'transparent'
		}
	},
	credits: {
		enabled: false
	},

	// Highstock specific
	navigator: {
		xAxis: {
			gridLineColor: '#D0D0D8',
			gridLineWidth: 1
		}
	},
	rangeSelector: {
		buttonTheme: {
			fill: 'white',
			stroke: '#C0C0C8',
			'stroke-width': 1,
			states: {
				select: {
					fill: '#D0D0D8'
				}
			}
		}
	},
	scrollbar: {
		trackBorderColor: '#C0C0C8'
	},

	// General
	background2: '#E0E0E8'

});

/* eslint-enable */



// WEBPACK FOOTER //
// ./src/config/highcharts.js